import { MatDateFormats } from "@angular/material/core";

/**
 * Change the default material date format from dd/mm/yyyy to yyyy-MM-dd
 */
export const MGD_DATE_FORMATS: MatDateFormats = {
    parse: {
        dateInput: "yyyy-MM-dd"
    },
    display: {
        dateInput: "yyyy-MM-dd",
        monthYearLabel: "MMMM yyyy",
        dateA11yLabel: "DD",
        monthYearA11yLabel: "MMMM yyyy"
    }
};
